import React from 'react';
import HireTeamCards from './hire-team-cards';
import ServicesCards from './services-cards';
import '../services.css'
import { useAppContext } from '../../../context/app-context';

const ProductCards = () => {
    const { activeTab, setActiveTab } = useAppContext()

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="products-tab tabs-container">
            <div className="tabs-header mt-0 pt-3">
                <div
                    className={`tab ${activeTab === 'Hire Team' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Hire Team')}
                >
                    Hire <span className="d-none d-lg-inline">Your Dream Tech Team</span>
                </div>
                <div
                    className={`tab ${activeTab === 'Services' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Services')}
                >
                    Build <span className="d-none d-lg-inline">Your Software Product</span>
                </div>
            </div>
            <div className="tabs-content">
                {activeTab === 'Hire Team' && (
                    <div className="tab-content">
                        <HireTeamCards />
                    </div>
                )}
                {activeTab === 'Services' && (
                    <div className="tab-content">
                        <ServicesCards />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductCards;
